var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MultiItemBox',{attrs:{"data":_vm.value,"addText":"添加表格列","supportSort":true,"prop":{
    label: 'showName',
    value: 'columnId'
  }},on:{"add":function($event){return _vm.onEditTableColumn()},"edit":_vm.onEditTableColumn,"delete":_vm.onRemoveTableColumn}})
}
var staticRenderFns = []

export { render, staticRenderFns }